import React from 'react'
import SeatTrapezoidBackImage from '../../../../assets/products/bench-window-seat-trapezoid-back.webp'

const SeatTrapezoidBack = () => {
  return (
    <svg
      width="650"
      height="433"
      viewBox="0 0 583 433"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <image x="-430" y="-130" width="1080" height="760" xlinkHref={SeatTrapezoidBackImage} />
      <g id="Group 1495">
        <g id="D-Comp">
          <g filter="url(#filter0_d_7407_12586)">
            <rect
              id="D-Background"
              x="234.586"
              y="31.7131"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(80.7036 234.586 31.7131)"
              fill="transparent"
            />
            <text
              id="D-Text"
              transform="translate(210.166 48.7551)"
              fill="#FFFFFF99"
              fontFamily="Roboto"
              fontSize="18"
              fontWeight="bold"
              letterSpacing="0px"
            >
              <tspan x="1.64648" y="12.7969">
                D
              </tspan>
            </text>
          </g>
          <path
            id="D-Line"
            d="M437.937 56.5433C438.098 56.319 438.047 56.0066 437.823 55.8454L434.169 53.2193C433.945 53.0581 433.632 53.1093 433.471 53.3335C433.31 53.5577 433.361 53.8702 433.585 54.0313L436.833 56.3657L434.499 59.6139C434.338 59.8381 434.389 60.1505 434.613 60.3117C434.838 60.4729 435.15 60.4217 435.311 60.1975L437.937 56.5433ZM9.18793 126.009C9.02679 126.233 9.07793 126.546 9.30216 126.707L12.9564 129.333C13.1806 129.494 13.4931 129.443 13.6542 129.219C13.8153 128.995 13.7642 128.682 13.54 128.521L10.2918 126.187L12.6262 122.939C12.7873 122.714 12.7362 122.402 12.5119 122.241C12.2877 122.08 11.9753 122.131 11.8141 122.355L9.18793 126.009ZM437.45 55.758L434.962 56.1653L435.124 57.1522L437.612 56.7449L437.45 55.758ZM429.986 56.9798L425.01 57.7944L425.172 58.7812L430.148 57.9667L429.986 56.9798ZM420.034 58.6089L415.058 59.4234L415.22 60.4103L420.196 59.5958L420.034 58.6089ZM410.082 60.2379L405.106 61.0525L405.268 62.0393L410.244 61.2248L410.082 60.2379ZM400.13 61.867L395.154 62.6815L395.316 63.6684L400.292 62.8539L400.13 61.867ZM390.178 63.4961L385.202 64.3106L385.364 65.2975L390.34 64.4829L390.178 63.4961ZM380.226 65.1251L375.25 65.9397L375.412 66.9265L380.388 66.112L380.226 65.1251ZM370.274 66.7542L365.298 67.5687L365.46 68.5556L370.436 67.741L370.274 66.7542ZM360.322 68.3832L355.346 69.1978L355.508 70.1846L360.484 69.3701L360.322 68.3832ZM350.37 70.0123L345.394 70.8268L345.556 71.8137L350.532 70.9992L350.37 70.0123ZM340.418 71.6414L335.442 72.4559L335.604 73.4428L340.58 72.6282L340.418 71.6414ZM330.466 73.2704L325.49 74.0849L325.652 75.0718L330.628 74.2573L330.466 73.2704ZM320.514 74.8995L315.538 75.714L315.7 76.7009L320.676 75.8863L320.514 74.8995ZM310.562 76.5285L305.586 77.3431L305.748 78.3299L310.724 77.5154L310.562 76.5285ZM300.61 78.1576L295.634 78.9721L295.796 79.959L300.772 79.1445L300.61 78.1576ZM290.658 79.7866L285.682 80.6012L285.844 81.588L290.82 80.7735L290.658 79.7866ZM280.706 81.4157L275.73 82.2302L275.892 83.2171L280.868 82.4026L280.706 81.4157ZM270.754 83.0448L265.778 83.8593L265.94 84.8462L270.916 84.0316L270.754 83.0448ZM260.802 84.6738L255.826 85.4884L255.988 86.4752L260.964 85.6607L260.802 84.6738ZM250.85 86.3029L245.874 87.1174L246.036 88.1043L251.012 87.2897L250.85 86.3029ZM240.898 87.9319L235.922 88.7465L236.084 89.7333L241.06 88.9188L240.898 87.9319ZM230.946 89.561L225.97 90.3755L226.131 91.3624L231.108 90.5479L230.946 89.561ZM220.994 91.1901L216.018 92.0046L216.179 92.9915L221.155 92.1769L220.994 91.1901ZM211.042 92.8191L206.066 93.6336L206.227 94.6205L211.203 93.806L211.042 92.8191ZM201.09 94.4482L196.114 95.2627L196.275 96.2496L201.251 95.435L201.09 94.4482ZM191.138 96.0772L186.162 96.8918L186.323 97.8786L191.299 97.0641L191.138 96.0772ZM181.186 97.7063L176.21 98.5208L176.371 99.5077L181.347 98.6932L181.186 97.7063ZM171.234 99.3353L166.258 100.15L166.419 101.137L171.395 100.322L171.234 99.3353ZM161.282 100.964L156.306 101.779L156.467 102.766L161.443 101.951L161.282 100.964ZM151.33 102.593L146.354 103.408L146.515 104.395L151.491 103.58L151.33 102.593ZM141.378 104.223L136.402 105.037L136.563 106.024L141.539 105.209L141.378 104.223ZM131.426 105.852L126.45 106.666L126.611 107.653L131.587 106.838L131.426 105.852ZM121.474 107.481L116.498 108.295L116.659 109.282L121.635 108.468L121.474 107.481ZM111.522 109.11L106.546 109.924L106.707 110.911L111.683 110.097L111.522 109.11ZM101.57 110.739L96.5936 111.553L96.7552 112.54L101.731 111.726L101.57 110.739ZM91.6176 112.368L86.6416 113.182L86.8032 114.169L91.7792 113.355L91.6176 112.368ZM81.6656 113.997L76.6896 114.811L76.8511 115.798L81.8272 114.984L81.6656 113.997ZM71.7136 115.626L66.7376 116.44L66.8991 117.427L71.8751 116.613L71.7136 115.626ZM61.7616 117.255L56.7856 118.07L56.9471 119.056L61.9231 118.242L61.7616 117.255ZM51.8095 118.884L46.8335 119.699L46.9951 120.685L51.9711 119.871L51.8095 118.884ZM41.8575 120.513L36.8815 121.328L37.0431 122.315L42.0191 121.5L41.8575 120.513ZM31.9055 122.142L26.9295 122.957L27.091 123.944L32.067 123.129L31.9055 122.142ZM21.9535 123.771L16.9775 124.586L17.139 125.573L22.115 124.758L21.9535 123.771ZM12.0014 125.4L9.51321 125.808L9.67475 126.794L12.163 126.387L12.0014 125.4Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter1_d_7407_12586)">
            <rect
              id="C-Background"
              x="216.629"
              y="192.976"
              width="41"
              height="41"
              rx="20.5"
              fill="transparent"
            />
            <text
              id="C-Text"
              transform="translate(229.193 207.514) rotate(-3.99845)"
              fill="#FFFFFF99"
              fontFamily="Roboto"
              fontSize="18"
              fontWeight="bold"
              letterSpacing="0px"
            >
              <tspan x="1.61133" y="12.7969">
                C
              </tspan>
            </text>
          </g>
          <path
            id="C-Line"
            d="M219.349 126.062C219.076 126.019 218.82 126.206 218.777 126.479L218.084 130.925C218.041 131.198 218.228 131.454 218.501 131.496C218.774 131.539 219.029 131.352 219.072 131.079L219.688 127.127L223.641 127.743C223.914 127.786 224.169 127.599 224.212 127.327C224.254 127.054 224.068 126.798 223.795 126.755L219.349 126.062ZM304.698 244.157C304.971 244.2 305.226 244.013 305.269 243.74L305.963 239.294C306.005 239.021 305.818 238.766 305.546 238.723C305.273 238.681 305.017 238.867 304.974 239.14L304.358 243.092L300.406 242.476C300.133 242.433 299.877 242.62 299.835 242.893C299.792 243.166 299.979 243.421 300.252 243.464L304.698 244.157ZM218.868 126.851L220.293 128.803L221.1 128.213L219.675 126.261L218.868 126.851ZM223.143 132.706L225.993 136.61L226.801 136.02L223.95 132.116L223.143 132.706ZM228.843 140.513L231.693 144.417L232.501 143.827L229.651 139.924L228.843 140.513ZM234.543 148.32L237.393 152.224L238.201 151.634L235.351 147.731L234.543 148.32ZM240.244 156.128L243.094 160.031L243.901 159.442L241.051 155.538L240.244 156.128ZM245.944 163.935L248.794 167.838L249.602 167.249L246.751 163.345L245.944 163.935ZM251.644 171.742L254.494 175.646L255.302 175.056L252.452 171.152L251.644 171.742ZM257.344 179.549L260.194 183.453L261.002 182.863L258.152 178.959L257.344 179.549ZM263.044 187.356L265.895 191.26L266.702 190.67L263.852 186.767L263.044 187.356ZM268.745 195.163L271.595 199.067L272.402 198.477L269.552 194.574L268.745 195.163ZM274.445 202.971L277.295 206.874L278.103 206.284L275.253 202.381L274.445 202.971ZM280.145 210.778L282.995 214.681L283.803 214.092L280.953 210.188L280.145 210.778ZM285.845 218.585L288.696 222.489L289.503 221.899L286.653 217.995L285.845 218.585ZM291.546 226.392L294.396 230.296L295.203 229.706L292.353 225.802L291.546 226.392ZM297.246 234.199L300.096 238.103L300.904 237.513L298.054 233.61L297.246 234.199ZM302.946 242.006L304.371 243.958L305.179 243.369L303.754 241.417L302.946 242.006Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter2_d_7407_12586)">
            <rect
              id="B-Background"
              x="319.348"
              y="396.065"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 319.348 396.065)"
              fill="transparent"
            />
            <text
              id="B-Text"
              transform="translate(328.307 365.587) rotate(0.543042)"
              fill="#FFFFFF99"
              fontFamily="Roboto"
              fontSize="18"
              fontWeight="bold"
              letterSpacing="0px"
            >
              <tspan x="1.75195" y="12.7969">
                B
              </tspan>
            </text>
          </g>
          <path
            id="B-Line"
            d="M184.631 362.825C184.474 363.053 184.532 363.364 184.76 363.52L188.471 366.066C188.699 366.222 189.01 366.164 189.166 365.936C189.322 365.708 189.264 365.397 189.037 365.241L185.738 362.978L188.001 359.68C188.157 359.452 188.099 359.141 187.871 358.985C187.643 358.828 187.332 358.886 187.176 359.114L184.631 362.825ZM473.49 309.725C473.646 309.497 473.588 309.186 473.361 309.029L469.65 306.484C469.422 306.328 469.111 306.386 468.954 306.614C468.798 306.841 468.856 307.153 469.084 307.309L472.383 309.571L470.12 312.87C469.964 313.098 470.022 313.409 470.25 313.565C470.477 313.721 470.789 313.663 470.945 313.436L473.49 309.725ZM185.135 363.599L187.618 363.137L187.434 362.154L184.951 362.616L185.135 363.599ZM192.584 362.212L197.55 361.286L197.367 360.303L192.401 361.228L192.584 362.212ZM202.516 360.361L207.482 359.436L207.299 358.453L202.333 359.378L202.516 360.361ZM212.448 358.51L217.414 357.585L217.231 356.602L212.265 357.527L212.448 358.51ZM222.38 356.66L227.347 355.735L227.163 354.752L222.197 355.677L222.38 356.66ZM232.313 354.809L237.279 353.884L237.096 352.901L232.129 353.826L232.313 354.809ZM242.245 352.959L247.211 352.033L247.028 351.05L242.062 351.976L242.245 352.959ZM252.177 351.108L257.143 350.183L256.96 349.2L251.994 350.125L252.177 351.108ZM262.109 349.258L267.075 348.332L266.892 347.349L261.926 348.275L262.109 349.258ZM272.042 347.407L277.008 346.482L276.825 345.499L271.858 346.424L272.042 347.407ZM281.974 345.557L286.94 344.631L286.757 343.648L281.791 344.573L281.974 345.557ZM291.906 343.706L296.872 342.781L296.689 341.798L291.723 342.723L291.906 343.706ZM301.838 341.855L306.804 340.93L306.621 339.947L301.655 340.872L301.838 341.855ZM311.771 340.005L316.737 339.08L316.553 338.096L311.587 339.022L311.771 340.005ZM321.703 338.154L326.669 337.229L326.486 336.246L321.52 337.171L321.703 338.154ZM331.635 336.304L336.601 335.378L336.418 334.395L331.452 335.321L331.635 336.304ZM341.567 334.453L346.533 333.528L346.35 332.545L341.384 333.47L341.567 334.453ZM351.499 332.603L356.466 331.677L356.282 330.694L351.316 331.62L351.499 332.603ZM361.432 330.752L366.398 329.827L366.215 328.844L361.248 329.769L361.432 330.752ZM371.364 328.902L376.33 327.976L376.147 326.993L371.181 327.918L371.364 328.902ZM381.296 327.051L386.262 326.126L386.079 325.143L381.113 326.068L381.296 327.051ZM391.228 325.2L396.194 324.275L396.011 323.292L391.045 324.217L391.228 325.2ZM401.161 323.35L406.127 322.425L405.944 321.441L400.977 322.367L401.161 323.35ZM411.093 321.499L416.059 320.574L415.876 319.591L410.91 320.516L411.093 321.499ZM421.025 319.649L425.991 318.723L425.808 317.74L420.842 318.666L421.025 319.649ZM430.957 317.798L435.923 316.873L435.74 315.89L430.774 316.815L430.957 317.798ZM440.889 315.948L445.856 315.022L445.672 314.039L440.706 314.965L440.889 315.948ZM450.822 314.097L455.788 313.172L455.605 312.189L450.639 313.114L450.822 314.097ZM460.754 312.247L465.72 311.321L465.537 310.338L460.571 311.263L460.754 312.247ZM470.686 310.396L473.169 309.933L472.986 308.95L470.503 309.413L470.686 310.396Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter3_d_7407_12586)">
            <rect
              id="A-Background"
              x="550.732"
              y="278.577"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 550.732 278.577)"
              fill="transparent"
            />
            <text
              id="A-Text"
              fill="#FFFFFF99"
              fontFamily="Roboto"
              fontSize="18"
              fontWeight="bold"
              letterSpacing="0px"
            >
              <tspan x="526.371" y="262.401">
                A
              </tspan>
            </text>
          </g>
          <path
            id="A-Line"
            d="M493.441 275.057C493.615 275.271 493.93 275.303 494.144 275.129L497.632 272.286C497.846 272.111 497.878 271.796 497.704 271.582C497.529 271.368 497.215 271.336 497 271.51L493.9 274.038L491.373 270.937C491.198 270.723 490.883 270.691 490.669 270.865C490.455 271.04 490.423 271.355 490.598 271.569L493.441 275.057ZM498.769 229.749C498.595 229.535 498.28 229.503 498.066 229.678L494.578 232.52C494.364 232.695 494.332 233.01 494.506 233.224C494.681 233.438 494.995 233.47 495.21 233.296L498.31 230.769L500.837 233.869C501.012 234.083 501.327 234.115 501.541 233.941C501.755 233.767 501.787 233.452 501.612 233.238L498.769 229.749ZM494.326 274.792L494.61 271.999L493.615 271.898L493.331 274.69L494.326 274.792ZM495.179 266.415L495.749 260.83L494.754 260.729L494.185 266.314L495.179 266.415ZM496.318 255.246L496.887 249.662L495.892 249.56L495.323 255.145L496.318 255.246ZM497.456 244.077L498.025 238.493L497.031 238.391L496.461 243.976L497.456 244.077ZM498.595 232.908L498.879 230.116L497.884 230.014L497.6 232.807L498.595 232.908Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_7407_12586"
          x="164.125"
          y="11.7131"
          width="107.084"
          height="107.085"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7407_12586" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7407_12586"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7407_12586"
          x="186.629"
          y="172.976"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7407_12586" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7407_12586"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_7407_12586"
          x="281.838"
          y="328.249"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7407_12586" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7407_12586"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7407_12586"
          x="479.943"
          y="213.631"
          width="104.947"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7407_12586" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7407_12586"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SeatTrapezoidBack
